<template>
  <page-header-wrapper>
    <a-card :bordered="false">
      <!-- 条件搜索 -->
      <div class="table-page-search-wrapper">
        <a-form layout="inline" labelAlign="right">
          <div class="table-page-search-wrapper">
            <a-form layout="inline" labelAlign="right">
              <a-row :gutter="48">
                <a-col :md="6" :sm="24">
                  <a-form-item label="方案名称">
                    <a-input v-model="queryParam.schemeName" placeholder="请输入" allow-clear />
                  </a-form-item>
                </a-col>
                       <a-col :md="6" :sm="24" v-if=" userType == 0">
              <a-form-item label="企业">
                <a-input v-model="queryParam.tenantFirmName" placeholder="请输入" allow-clear />
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24" v-if=" userType == 1 || userType==0">
              <a-form-item label="经销商">
                <a-input v-model="queryParam.tenantName" placeholder="请输入" allow-clear />
              </a-form-item>
            </a-col>
                <a-col :md="8" :sm="24">
                  <a-form-item label="创建时间">
                    <a-range-picker
                      format="YYYY-MM-DD"
                      v-model="timeValue"
                      :placeholder="['开始时间', '结束时间']"
                      @change="onChangeTime"
                    />
                  </a-form-item>
                </a-col>
           
                <a-col :md="6" :sm="24">
                  <span class="table-page-search-submitButtons">
                    <a-button type="primary" @click="handleQuery"><a-icon type="search" />查询</a-button>
                    <a-button style="margin-left: 8px" @click="resetQuery"><a-icon type="redo" />重置</a-button>
                  </span>
                </a-col>
              </a-row>
            </a-form>
          </div>
        </a-form>
      </div>
      <!-- 操作 -->
      <div class="table-operations">
        <template v-if="isOperate">
          <a-button type="primary" @click="$refs.vrForm.handleAdd()" v-hasPermi="['abm-fix:dev:add']">
            <a-icon type="plus" />新增
          </a-button>
        </template>
        <table-setting
          :style="{ float: 'right' }"
          :table-size.sync="tableSize"
          v-model="columns"
          :refresh-loading="loading"
          @refresh="getList"
        />
      </div>
      <!-- 增加修改 -->
      <vrForm ref="vrForm" @ok="getList" />
      <!-- 数据展示 -->
      <a-table
        :loading="loading"
        :size="tableSize"
        rowKey="id"
        :columns="columns"
        :data-source="list"
        :pagination="false"
        :bordered="tableBordered"
      >
        <!-- <span slot="coverImageUrl" slot-scope="text, record">
          <a-image :src="record.coverImageUrl" style="width: 70px; height: 70px" />
        </span> -->
        <!-- <span slot="coverImageUrl" slot-scope="text, record">
          <a-image :src="record.coverImageUrl" style="width: 70px; height: 70px" />
        </span>
        <span slot="coverImageUrl" slot-scope="text, record">
          <div v-viewer v-if="record.coverImageUrl">
            <img :src="$url + record.coverImageUrl" alt="" style="width: 50px; height: 50px" />
          </div>
        </span> -->
        <span slot="startupPageUrl" slot-scope="text, record">
          <div v-viewer v-if="record.startupPageUrl">
            <img :src="$url + record.startupPageUrl" alt="" style="width: 50px; height: 50px" />
          </div>
        </span>
        <span slot="floorLogoUrl" slot-scope="text, record">
          <div v-viewer v-if="record.floorLogoUrl">
            <img :src="$url + record.floorLogoUrl" alt="" style="width: 50px; height: 50px" />
          </div>
        </span>
        <span slot="linkLogoUrl" slot-scope="text, record">
          <div v-viewer v-if="record.linkLogoUrl">
            <img :src="$url + record.linkLogoUrl" alt="" style="width: 50px; height: 50px" />
          </div>
        </span>
        <span slot="cuttingStatus" slot-scope="text, record">
          <span v-if="record.cuttingStatus == 0">未开始</span>
          <span v-if="record.cuttingStatus == 1">进行中</span>
          <span v-if="record.cuttingStatus == 2">已完成</span>
          <span v-if="record.cuttingStatus == 3">失败</span>
        </span>
          <span slot="tenantName" slot-scope="text, record">
          <span v-if="record.tenantId !== record.tenantFirmId"> {{ record.tenantName }}</span>
        </span>
        <span slot="action" slot-scope="text, record">
          <a
            @click="$refs.vrForm.handleUpdate(record, undefined)"
            v-hasPermi="['09e2494e39d5b8c1371914305721d55bd:0:d']"
          >
            编辑
          </a>
          <a-divider type="vertical" v-hasPermi="['09e2494e39d5b8c1371914305721d55br:0:r']" />
          <a @click="handleDelete(record)" v-hasPermi="['09e2494e39d5b8c1371914305721d55br:0:r']"> 删除 </a>
        </span>
      </a-table>
      <!-- 分页 -->
      <a-pagination
        class="ant-table-pagination"
        show-size-changer
        show-quick-jumper
        :current="queryParam.pageNum"
        :total="total"
        :page-size="queryParam.pageSize"
        :showTotal="(total) => `共 ${total} 条`"
        @showSizeChange="onShowSizeChange"
        @change="changeSize"
      />
    </a-card>
  </page-header-wrapper>
</template>

<script>
import { fetchList, delObj } from '@/api/VR/vrPlan/index'
import vrForm from './model/vrForm'
import { tableMixin } from '@/store/table-mixin'
import { listTenant } from '@/api/system/tenant'
import { mapGetters } from 'vuex'
import moment from 'moment'
export default {
  name: 'Post',
  components: {
    vrForm,
  },
  mixins: [tableMixin],
  dicts: ['sys_enable_disable'],
  props: {
    isOperate: {
      type: Boolean,
      default: true,
    },
    tenantFirmId: {
      type: [String, Number],
    },
    tenantId: {
      type: [String, Number],
    },
  },
  data() {
    return {
      timeValue: [],
      list: [],
      userList: [],
      selectedRowKeys: [],
      selectedRows: [],
      // 高级搜索 展开/关闭
      advanced: false,
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      ids: [],
      loading: false,
      total: 0,
      queryParam: {
        pageNum: 1,
        pageSize: 10,
        tenantFirmId: undefined,
        postName: undefined,
        status: undefined,
      },
      columns: [
        {
          title: '方案名称',
          dataIndex: 'schemeName',
          width: '130px',
          align: 'center',
          key: 'schemeName',
        },
        {
          title: '企业',
          dataIndex: 'tenantFirmName',
          width: '100px',
          align: 'center',

        },
        {
          title: '经销商',
          width: '100px',
          dataIndex: 'tenantName',
          align: 'center',
          scopedSlots: { customRender: 'tenantName' },
          key: 'tenantName',
        },
        {
          title: '补地图',
          dataIndex: 'floorLogoUrl',
          align: 'center',
          scopedSlots: { customRender: 'floorLogoUrl' },
          key: 'floorLogoUrl',
        },
        {
          title: '分享图',
          dataIndex: 'linkLogoUrl',
          align: 'center',
          scopedSlots: { customRender: 'linkLogoUrl' },
        },
        {
          title: '启动页',
          dataIndex: 'startupPageUrl',
          align: 'center',
          scopedSlots: { customRender: 'startupPageUrl' },
          key: 'startupPageUrl',
        },
        {
          title: '企业介绍',
          dataIndex: 'companyIntroShort',
          align: 'center',
          scopedSlots: { customRender: 'companyIntroShort' },
        },
        {
          title: '创建时间',
          dataIndex: 'createTime',
          align: 'center',
          key: 'createTime',
        },
        {
          title: '操作',
          dataIndex: 'action',
          key: 'action',
          scopedSlots: { customRender: 'action' },
        },
      ],
    }
  },
  filters: {},
  created() {
    if (this.userType == 1) {
      this.columns.splice(1, 1)
    }
    if (this.userType == 2) {
      this.columns.splice(2, 1)
    }
    // this.queryParam.tenantFirmId = this.tenantFirmId
    // this.queryParam.tenantId = this.tenantId
    this.getList()
    // if (!this.tenantFirmId) {
    //   this.getQi()
    // }
  },
  computed: {
    userType() {
      return this.$store.state.user.userTentant.type
    },
  },
  watch: {},
  methods: {
    // type
    // 点击批量添加设备
    handleUpload() {
      this.uploadAdd = true
      this.$nextTick(() => {
        this.$refs.uploadAdd.init(3)
      })
    },
    // 查询企业品牌
    getQi() {
      const query = {
        pageNum: 1,
        pageSize: 999,
        type: 1,
        status: 0,
      }
      listTenant(query).then((res) => {
        console.log(res, '的点点滴滴')
        this.userList = res.data.records
      })
    },
    filterOption(input, option) {
      return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
    },
    /** 查询部门列表 */
    getList() {
      this.loading = true
      fetchList(this.queryParam).then((response) => {
        this.list = response.data.records
        this.total = response.data.total
        this.loading = false
      })
    },
    // 点击确定
    onChange(e) {
      console.log(e, '的点点滴滴')
    },
    /** 搜索按钮操作 */
    handleQuery() {
      this.queryParam.pageNum = 1
      this.getList()
    },
    /** 重置按钮操作 */
    resetQuery() {
      this.queryParam = {
        pageNum: 1,
        pageSize: 10,
        postCode: undefined,
        postName: undefined,
        status: undefined,
      }
      this.timeValue = []
      this.handleQuery()
    },
    onChangeTime(e) {
      this.queryParam.createBeginTime = moment(e[0]).startOf('day').format('YYYY-MM-DD') + ' 00:00:00'
      this.queryParam.createEndTime = moment(e[1]).endOf('day').format('YYYY-MM-DD') + ' 23:59:59'
    },
    onShowSizeChange(current, pageSize) {
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    changeSize(current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    onSelectChange(selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
      this.ids = this.selectedRows.map((item) => item.id)
      this.single = selectedRowKeys.length !== 1
      this.multiple = !selectedRowKeys.length
    },
    toggleAdvanced() {
      this.advanced = !this.advanced
    },
    /** 删除按钮操作 */
    handleDelete(row) {
      var that = this
      let ids = []
      if (row.schemeId) {
        ids = [row.schemeId]
      } else {
        ids = this.ids
      }
      this.$confirm({
        title: '是否确认删除此数据?',
        onOk() {
          return delObj(ids).then(() => {
            that.onSelectChange([], [])
            that.getList()
            that.$message.success('删除成功', 3)
          })
        },
        onCancel() {},
      })
    },
    /** 导出按钮操作 */
    handleExport() {
      var that = this
      this.$confirm({
        title: '是否确认导出?',
        content: '此操作将导出当前条件下所有数据而非选中数据',
        onOk() {
          that.download(
            'fix/dev/export',
            {
              ...that.queryParam,
            },
            `设备信息${new Date().getTime()}.xlsx`
          )
        },
        onCancel() {},
      })
    },
  },
}
</script>
